// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2aES-","consentsList":"PatientConsents_consentsList__kSLXI","consentsListEmpty":"PatientConsents_consentsListEmpty__1RXnM"};